/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import ds, { media } from 'designsystem';
import { Row, Column } from 'hedron';
import FlexColumn from 'blocks/FlexColumn/FlexColumn';
import { Accordion as AccordionModel } from 'models';
import Container from 'blocks/Container/Container';
import SCROLL from 'common/consts/scroll';
import { scrollToElement } from 'animations/Animations';
import ScrollDiv from 'blocks/ScrollDiv';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import PanelGroup from './PanelGroup';

const Accordion = styled.div`
  margin: ${ds.get('metrics.m')} auto;
  padding: ${ds.get('metrics.s')};
  padding-top: 0;
  width: 100%;

  ${media.desktop`
    margin: ${ds.get('metrics.xl')} auto;
  `};
`;

const SimpleText = styled.span``;

@inject('windowStore')
@observer
export default class AccordionBlock extends Component {
  activeKey = observable.box(0);

  static propTypes = {
    data: PropTypes.instanceOf(AccordionModel).isRequired,
  };

  constructor(props) {
    super(props);
    const {
      data: {
        accordionItems,
      },
    } = this.props;
    this.scrollDivRefs = accordionItems.map(() => React.createRef());
  }

  scrollToHeader(elementRefIndex) {
    if (elementRefIndex > 0) {
      const scrollDivRef = this.scrollDivRefs[elementRefIndex - 1].current;
      scrollToElement(scrollDivRef, 300);
    } else {
      scrollToElement(this.scrollDivRefs[0].current, 0);
    }
  }

  render() {
    const {
      data: {
        accordionItems,
        htmlModifiers,
      },
      windowStore,
      windowStore: {
        isOnTablet,
      },
    } = this.props;
    const isAccordionSpread = (!!this.activeKey.get() || this.activeKey.get() === 0);
    const scrollDivOffset = (isOnTablet ? `-${SCROLL.MOBILE_TOP_OFFSET}px` : `-${SCROLL.DESKTOP_TOP_OFFSET}px`);
    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
      >
        <Container>
          <Accordion>
            <PanelGroup
              accordion
              defaultActiveKey={0}
              activeKey={this.activeKey.get()}
              onSelect={activeKey => this.activeKey.set(activeKey)}
              id="FAQ.LeftPanel"
            >
              {accordionItems.map((question, index) => {
                const isActive = this.activeKey.get() === index;
                const isSmallParagraphEmpty = question.smallText === '<p><br></p>';
                return (
                  <PanelGroup.Panel
                    eventKey={index}
                    key={question.system.id}
                  >
                    <PanelGroup.Heading data-isactive={isActive}>
                      <PanelGroup.Title
                        toggle
                        onClick={() => this.scrollToHeader(index)}
                      >
                        <ScrollDiv
                          offset={scrollDivOffset}
                          innerRef={this.scrollDivRefs[index]}
                        />
                        <PanelGroup.TitleText isActive={isActive}>
                          <SimpleText
                            dangerouslySetInnerHTML={{ __html: safeHtmlWithBr(question.title) }}
                          />
                          <PanelGroup.Arrow
                            isActive={isActive}
                          />
                        </PanelGroup.TitleText>
                      </PanelGroup.Title>
                    </PanelGroup.Heading>
                    <PanelGroup.Body
                      data-isspread={isAccordionSpread}
                      collapsible
                    >
                      <Row alignItems="flex-start">
                        <Column lg={4} fluid>
                          <PanelGroup.Body.Paragraph
                            dangerouslySetInnerHTML={{
                              __html: question.text,
                            }}
                          />
                        </Column>

                        {!isOnTablet && (
                          <FlexColumn
                            lg={3}
                            lgShift={1}
                            align="flex-end"
                            fluid
                          >
                            {question.image && <PanelGroup.Body.Image src={windowStore.adjustImageSize(question.image)} />}
                          </FlexColumn>
                        )}

                        <Column
                          lg={2}
                          lgShift={1}
                          fluid
                        >
                          {question.smallText
                          && (
                            <PanelGroup.Body.Paragraph
                              isEmpty={isSmallParagraphEmpty}
                              dangerouslySetInnerHTML={{
                                __html: question.smallText,
                              }}
                            />
                          )}
                        </Column>

                        {isOnTablet && (
                          <FlexColumn
                            lg={3}
                            lgShift={1}
                            align="flex-end"
                            fluid
                          >
                            {question.image && <PanelGroup.Body.Image src={windowStore.adjustImageSize(question.image)} />}
                          </FlexColumn>
                        )}
                      </Row>
                    </PanelGroup.Body>
                  </PanelGroup.Panel>
                );
              })}
            </PanelGroup>
          </Accordion>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/index.jsx